var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 42,
    viewBox: "0 0 150 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.883 6.32983L148.833 6.49241L148.893 6.65142C149.285 7.69218 149.5 8.82043 149.5 9.99999L149.5 32C149.5 37.2467 145.247 41.5 140 41.5L10 41.5C4.7533 41.5 0.5 37.2467 0.5 32V10C0.5 4.75329 4.7533 0.499996 10 0.499996L140 0.499992C141.713 0.499992 143.319 0.952923 144.705 1.74521L144.921 1.86827L145.149 1.77121C145.923 1.44217 146.66 1.07964 147.341 0.712158C147.966 0.375393 148.705 0.460583 149.254 0.822193C149.796 1.17971 150.094 1.76293 149.939 2.41094C149.651 3.61813 149.3 4.95649 148.883 6.32983Z",
    fill: "current",
    fillRule: "nonzero",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble4);
export default __webpack_public_path__ + "static/media/bubble4.b922478775e18d447b43fa3ee06cccf2.svg";
export { ForwardRef as ReactComponent };